import { useCallback, useState } from "react";

import { SESSION_STORAGE } from "@/constants";

type RequestLogId = string | number | null | undefined;

const readStoredId = (): string | null => {
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE.RECENTLY_VIEWED_REQUEST_LOG_ID);
    return raw && raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
};

export const useRecentlyViewedRequestLogSession = () => {
  const [recentlyViewedRequestId, setRecentlyViewedRequestId] = useState<string | null>(() =>
    readStoredId(),
  );

  const markRecentlyViewedRequest = useCallback((id: RequestLogId) => {
    if (id === undefined || id === null) {
      return;
    }
    const asString = String(id);
    if (asString.startsWith("__placeholder-")) {
      return;
    }
    try {
      sessionStorage.setItem(SESSION_STORAGE.RECENTLY_VIEWED_REQUEST_LOG_ID, asString);
    } catch {
      // ignore quota / private mode
    }
    setRecentlyViewedRequestId(asString);
  }, []);

  return { recentlyViewedRequestId, markRecentlyViewedRequest };
};
